// extracted by mini-css-extract-plugin
export default {"fieldset":"DadosSolicitacao_fieldset__qoExS","justificativa":"DadosSolicitacao_justificativa__2HsIP","containerItems":"DadosSolicitacao_containerItems__0k0Zr"};